import React from 'react'
import PropTypes from 'prop-types'

import { HBox, Box } from 'app/views/core/Box'

const Button = ({ text, kind, onClick }) => (
  <button
    className={`uk-button${kind ? ` uk-button-${kind}` : ''}`}
    style={{ flexBasis: 200, margin: '0 20px' }}
    onClick={onClick}
  >
    {text}
  </button>
)

function LessonNagMessage(props) {
  const { onReturnToLesson, onLeaveAnyway } = props
  return (
    <div>
      <p>In order to complete this lesson, you must submit a patch that passes all tests.</p>
      <HBox>
        <Box grow={1} />
        <Button
          text="Back to Lesson"
          onClick={onReturnToLesson}
        />
        <Button
          text="Leave Anyway"
          kind="danger"
          onClick={onLeaveAnyway}
        />
        <Box grow={1} />
      </HBox>
    </div>
  )
}
LessonNagMessage.propTypes = {
  onReturnToLesson: PropTypes.func.isRequired,
  onLeaveAnyway: PropTypes.func.isRequired,
}

export default LessonNagMessage
